export default function DriveOff() {
  return (
    <section className="dashboard_tab">
      <h1>Drive Off report</h1>
    </section>
  );
}
